module.exports = __webpack_public_path__ + "img/product-shot_06.b1d32efd.jpg";